'use strict';
var utils = require('pagedesigner/util/utils');
var videoUtils = require('pagedesigner/util/videos');
var imagesLoaded = require('imagesloaded');
var _ = require('lodash');
var ada = require('org/components/ada');

/**
 * positions the slider controls over the image in mobile
 * @param {Object} $slider - the carousel
 */
function positionHeroControls($slider) {
    $slider.find('.slick-dots').css('top', '');
    if (utils.mediaBreakpointDown('md')) {
        let $elements = $slider.find('.text-block');
        if ($elements.length > 0) {
            let $tallestBlock = _.maxBy($elements, function (el) { return $(el).height(); });
            $slider.find('.slick-dots').css('top', ($tallestBlock.offsetHeight + 45) * -1);
        }
    }
}

/**
 * Inserts a play/pause button control on autoplay sliders
 * @param {Object} $slider - the carousel to modify
 */
function insertPlayButton($slider) {
    if (!$slider || $slider.find('.caro-control').length > 0) {
        return;
    }
    $slider.find('.slick-dots li:last-of-type').after(
        '<li class="caro-control" tabindex="0"><div class="toggle-button isPlaying"></div></li>'
    );
}

/**
 * ensures slides and mobile content blocks have the same height
 * @param {Object} $slides - the elements to sync
 */
function syncHelper($slides) {
    // only sync mobile content in heros
    utils.syncHeights($slides.find('.text-block.d-lg-none'));

    // all slides
    utils.syncHeights($slides);
}

/**
 * common carousel init
 * @param {Object} $slider - the elements to sync
 * @param {Object} configs - slider settings
 */
function initSlider($slider, configs) {
    var sliderConfigs = configs || $slider.data('slick');
    // get first child of each slide to sync heights
    var $slides = $slider.find('.pd-caro-item > div');

    // hide dots where there is only one slide; known slick bug
    $slider.on('init', function () {
        if ($slider.find('.slick-dots li:not(.pause)').length === 1) {
            $slider.find('.slick-dots').hide();
        }
        syncHelper($slides);
        if ($slider.hasClass('pd-hero-caro')) {
            positionHeroControls($slider);
            // Video Slide handlers
            videoUtils.videoControlsInit($slider);
        }
    });

    $slider.on('init afterChange', function () {
        ada.accessbileSliders($slider);
    });

    imagesLoaded($slider).on('done', function () {
        // initialize the slider
        $slider.slick(sliderConfigs);

        // if this is an autoplay slider, add a play/pause button
        // PD TODO: add keyboard accessibility
        if ($slider.hasClass('autoplay')) {
            insertPlayButton($slider);
        }
    }).on('always', function () {
        // insurance for lazy loaded images
        $slider.slick(sliderConfigs);
    });

    utils.smartResize(function () {
        // re-init if we have 'unslicked' the slider
        if (!$slider.hasClass('slick-initialized')) {
            $slides.css('height', '');
            $slider.slick(sliderConfigs);
        } else {
            syncHelper($slides);
        }

        if ($slider.hasClass('pd-hero-caro')) {
            positionHeroControls($slider);
        }
    });
}

var pdCarousels = {
    initEvents: function () {
        // events will be init'd on load
        $('body').on('click', '.toggle-button', function (e) {
            e.stopPropagation();
            var $btn = $(e.target);
            var $parentSlider = $btn.closest('.slick-slider');
            var isHero = $parentSlider.hasClass('pd-hero-caro');
            if ($btn.hasClass('isPaused')) {
                $parentSlider.slick('slickPlay');
                $btn.removeClass('isPaused').addClass('isPlaying');
                if (isHero) {
                    $parentSlider.find('.slick-active button').css('animation-play-state', 'running');
                }
            } else {
                $parentSlider.slick('slickPause');
                $btn.removeClass('isPlaying').addClass('isPaused');
                if (isHero) {
                    $parentSlider.find('.slick-active button').css('animation-play-state', 'paused');
                }
            }
        });
    },
    /**
     * @function
     * @desc Inits all sliders in Page Designer. Default Configs are overwritten via data attributes in the template.
     *       In the case that this is an Einstein carousel, we use an observer to ensure the slider gets initialized
     */
    pdContentCaro: function () {
        $('.pd-content-caro').not('.slick-initialized').each(function (idx) {
            // find and initialize all of the content carousels
            var $slider = $(this);
            var sliderID = 'pd-content-caro-' + idx;

            // assign a unique ID for optional targeting
            $slider.attr('id', sliderID);

            // hide dots where there is only one slide; known slick bug
            $slider.on('init', function () {
                // check PI recommendations content if this is a Product Tile slider
                if ($slider.find('.product-tile-pd').length > 0) {
                    utils.mutationObserver($slider, function () { pdCarousels.pdContentCaro(); });
                }

                // handle slider video card events
                if ($slider.find('[class$="videoComponent"]').length > 0) {
                    let $videoComponents = $('[class$="videoComponent"]');
                    $videoComponents.each(function () {
                        let $videoComponent = $(this);
                        videoUtils.initPosterImgEvents($videoComponent);
                    });
                }
            });

            initSlider($slider);
        });
    },
    /**
     * @function
     * @desc Inits the Custom Hero Slider. Default Configs are overwritten via data attributes in the template.
     *       In the case that this is an Einstein carousel, we use an observer to ensure the slider gets initialized
     */
    pdHeroCaro: function () {
        $('.pd-hero-caro').not('.slick-initialized').each(function (idx) {
            // find and initialize all of the hero carousels
            var $slider = $(this);
            var sliderID = 'pd-hero-caro-' + idx;

            // assign a unique ID for optional targeting
            $slider.attr('id', sliderID);

            initSlider($slider);
        });
    },
    /**
     * @function
     * @desc Inits the Product Detail Tile Use it With replenishment products slider
     */
    pdReplenishmentCaro: function () {
        var configs = {
            speed: 300,
            dots: true,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            mobileFirst: true,
            infinite: false
        };

        $('.replenishment-product-caro').not('.slick-initialized').each(function (idx) {
            // find and initialize all of the hero carousels
            var $slider = $(this);
            var sliderID = 'replenishment-product-caro-' + idx;
            // assign a unique ID for optional targeting
            $slider.attr('id', sliderID);
            $slider.slick(configs);
        });
    }
};

module.exports = pdCarousels;
